import {
  Box,
  Typography,
  Paper,
  Grid,
  Divider,
  TextField,
  Button,
  IconButton,
  MenuItem,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import AddIcon from "@mui/icons-material/Add";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { formatDate } from "../../utils/formatDate";

import * as services from "../../services/services";
import * as dropdown from "../../services/dropdown_service";

import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import IMG from "../../images/istockphoto.jpg";

const PetDetailPage = () => {
  const { id } = useParams();

  const [pet, setPet] = useState(null);
  const [vaccine_dropdown, setVaccineDropdown] = useState([]);
  const [parasite_dropdown, setParasiteDropdown] = useState([]);

  const [vaccineList, setVaccineList] = useState([
    {
      date: "",
      image: null,
      vaccineName: "",
      lotNo: "",
      expDate: "",
      nextDate: "",
    },
  ]);
  const [parasiteList, setParasiteList] = useState([
    {
      date: "",
      image: null,
      vaccineName: "",
      lotNo: "",
      expDate: "",
      nextDate: "",
    },
  ]);
  const [microchip, setMicrochip] = useState([]);
  const [vet, setVet] = useState({
    name: "",
    licenseNo: "",
    hospital: "",
    note: "",
  });

  const fetchPet = async () => {
    const res = await services.getPetHistoryById(id);
    setPet(res.data.data);
    setVaccineList(res.data.data.PetVaccineRecord);
    setMicrochip(res.data.data.PetMicrochipRecord);
    setParasiteList(res.data.data.petParasiteRecords);
    setVet({
      name:
        res.data.data.handledBy.title +
        " " +
        res.data.data.handledBy.name +
        " " +
        res.data.data.handledBy.lastname,
      hospital: res.data.data.hospital?.name,
      licenseNo: res.data.data.handledBy.license_no,
    });
      fetchVaccine(res.data.data?.pet?.typeId);
     fetchParasite(res.data.data?.pet?.typeId);
  };
  const fetchVaccine = async (typeId) => {
    const res = await dropdown.getVaccine(typeId);
    setVaccineDropdown(res.data.results);
  };
  const fetchParasite = async (typeId) => {
    const res = await dropdown.getParasite(typeId);
    setParasiteDropdown(res.data.results);
  };
  useEffect(() => {
    fetchPet();

  }, []);

  if (!pet) return <Typography>Loading...</Typography>;

  return (
    <>
      <AppBreadcrumbs />

      <Box sx={{ p: 2 }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          ประวัติการรับบริการ {pet.pet.hospitalPetCode}
        </Typography>

        {/* ==============================
              ข้อมูลสัตว์เลี้ยง
          =============================== */}
        <Paper sx={{ p: 2, mb: 4 }}>
          <Grid container spacing={2}>
            {/* รูป */}
            <Grid item xs={12} md={4}>
              <img
                src={pet.pet.image ? pet.pet.image : IMG}
                alt={pet.name}
                style={{ width: "70%", borderRadius: 8 }}
              />
            </Grid>

            {/* ข้อมูล */}
            <Grid item xs={12} md={8}>
              {/* ชื่อสัตว์ */}
              <Typography variant="h6" sx={{ mb: 2 }}>
                ชื่อ: {pet.pet.name}
              </Typography>

              {/* ---------- ส่วนที่ 1: ข้อมูลสัตว์เลี้ยง ---------- */}
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mt: 1 }}
              >
                ข้อมูลสัตว์เลี้ยง
              </Typography>

              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ชนิดสัตว์:
                  </Typography>{" "}
                  {pet.pet.type}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    สายพันธุ์:
                  </Typography>{" "}
                  {pet.pet.breed}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    วันเกิด:
                  </Typography>{" "}
                  {formatDate(pet.pet.birthdate)}
                </Grid>

                {/* <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ทำหมัน:
                  </Typography>{" "}
                  {pet.pet.sterilization_date ? "ทำแล้ว" : "ยัง"}
                </Grid> */}

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    สีตา:
                  </Typography>{" "}
                  {pet.pet.eyeColor}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    สีขน:
                  </Typography>{" "}
                  {pet.pet.furColor}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ตำหนิ:
                  </Typography>{" "}
                  {pet.pet.appearanceDetail || "-"}
                </Grid>

                <Grid item xs={12}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ไมโครชิป:
                  </Typography>{" "}
                  {pet.pet.microchipNumber || "-"}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    กรุ๊ปเลือด:
                  </Typography>{" "}
                  {pet.pet.bloodGroup}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    ยาที่แพ้:
                  </Typography>{" "}
                  {pet.pet.drugAllergies || "-"}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    อาหารที่แพ้:
                  </Typography>{" "}
                  {pet.pet.foodAllergies || "-"}
                </Grid>

                <Grid item xs={6}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    โรคประจำตัว:
                  </Typography>{" "}
                  {pet.pet.diseases || "-"}
                </Grid>
                {/* 
                <Grid item xs={12}>
                  <Typography sx={{ fontWeight: "bold", display: "inline" }}>
                    เจ้าของ:
                  </Typography>{" "}
                  {pet.pet.ownerName}
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>
        </Paper>

        {/* ==============================
              รายการวัคซีน
          =============================== */}
        {pet?.serviceType === "vaccine" &&
          vaccineList.map((item, index) => (
            <Paper key={index} sx={{ p: 2, mb: 3 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mb: 2 }}
              >
                รายละเอียดวัคซีน
              </Typography>
              {console.log(item)}

              <Grid container spacing={2}>
                {/* วันที่ฉีดวัคซีน */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="วันที่ได้รับวัคซีน"
                    fullWidth
                    type="date"
                    value={
                      pet.serviceDate
                        ? new Date(pet.serviceDate).toISOString().split("T")[0]
                        : ""
                    }
                    disabled
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                {/* Vaccine Sticker */}
                <Grid item xs={12}>
                  <Typography sx={{ mb: 1 }}>รูป Vaccine Sticker*</Typography>

                  <Box
                    sx={{
                      border: "2px dashed #ccc",
                      width: 200, // กำหนดความกว้างกรอบ
                      height: 200, // กำหนดความสูงกรอบ
                      margin: "0 auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      cursor: "default",
                      overflow: "hidden", // ป้องกันรูปล้นกรอบ
                    }}
                  >
                    {item.photo ? (
                      <img
                        src={item.photo}
                        alt="Vaccine Sticker"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover", // ครอปรูปเต็มกรอบ
                        }}
                      />
                    ) : (
                      <IconButton component="label">
                        <PhotoCamera fontSize="large" />
                      </IconButton>
                    )}
                  </Box>
                </Grid>

                {/* ชื่อวัคซีน */}
                <Grid item xs={12} md={6}>
                  <TextField
                    select
                    label="ชื่อวัคซีน / brand name vaccine"
                    fullWidth
                    value={item.product}
                    disabled
                  >
                    {vaccine_dropdown.map((item) => (
                      <MenuItem key={item.value} value={item.value} disabled>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <img
                            src={item.context.photo}
                            alt={item.label}
                            style={{
                              width: 32,
                              height: 32,
                              borderRadius: 4,
                              objectFit: "cover",
                            }}
                          />
                          <Typography>{item.label}</Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* Lot No */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Lot No."
                    placeholder="กรุณาใส่เลขที่การผลิต"
                    fullWidth
                    value={item.lotNumber}
                    disabled
                  />
                </Grid>

                {/* EXP Date */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="วันหมดอายุ / EXP date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={
                      item.expirationDate
                        ? new Date(item.expirationDate)
                            .toISOString()
                            .split("T")[0]
                        : ""
                    }
                    disabled
                  />
                </Grid>

                {/* Next date */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="วันที่นัดครั้งถัดไป"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={
                      item.appointedDate
                        ? new Date(item.appointedDate)
                            .toISOString()
                            .split("T")[0]
                        : ""
                    }
                    disabled
                  />
                </Grid>
              </Grid>
            </Paper>
          ))}
        {pet?.serviceType === "parasite" &&
          parasiteList.map((item, index) => (
            <Paper key={index} sx={{ p: 2, mb: 3 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mb: 2 }}
              >
                รายละเอียดการรับยาป้องกันพยาธิ
              </Typography>
              <Grid container spacing={2}>
                {/* วันที่ฉีดวัคซีน */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="วันที่ได้รับยา"
                    fullWidth
                    type="date"
                    value={
                      pet.serviceDate
                        ? new Date(pet.serviceDate).toISOString().split("T")[0]
                        : ""
                    }
                    disabled
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                {/* Vaccine Sticker */}
                <Grid item xs={12}>
                  <Typography sx={{ mb: 1 }}>รูปประกอบ</Typography>

                  <Box
                    sx={{
                      border: "2px dashed #ccc",
                      width: 200, // กำหนดความกว้างกรอบ
                      height: 200, // กำหนดความสูงกรอบ
                      margin: "0 auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      cursor: "default",
                      overflow: "hidden", // ป้องกันรูปล้นกรอบ
                    }}
                  >
                    {item.photo ? (
                      <img
                        src={item.photo}
                        alt="Vaccine Sticker"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover", // ครอปรูปเต็มกรอบ
                        }}
                      />
                    ) : (
                      <IconButton component="label">
                        <PhotoCamera fontSize="large" />
                      </IconButton>
                    )}
                  </Box>
                </Grid>

                {/* ชื่อวัคซีน */}
                <Grid item xs={12} md={6}>
                  <TextField
                    select
                    label="ชื่อยาที่ได้รับ"
                    fullWidth
                    value={item.product}
                    disabled
                  >
                    {parasite_dropdown.map((item) => (
                      <MenuItem key={item.value} value={item.value} disabled>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <img
                            src={item.context.photo}
                            alt={item.label}
                            style={{
                              width: 32,
                              height: 32,
                              borderRadius: 4,
                              objectFit: "cover",
                            }}
                          />
                          <Typography>{item.label}</Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* Lot No */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Lot No."
                    placeholder="กรุณาใส่เลขที่การผลิต"
                    fullWidth
                    value={item.lotNumber}
                    disabled
                  />
                </Grid>

                {/* EXP Date */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="วันหมดอายุ / EXP date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={
                      item.expirationDate
                        ? new Date(item.expirationDate)
                            .toISOString()
                            .split("T")[0]
                        : ""
                    }
                    disabled
                  />
                </Grid>

                {/* Next date */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="วันที่นัดครั้งถัดไป"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={
                      item.appointedDate
                        ? new Date(item.appointedDate)
                            .toISOString()
                            .split("T")[0]
                        : ""
                    }
                    disabled
                  />
                </Grid>
              </Grid>
            </Paper>
          ))}
        {pet?.serviceType === "microchip" &&
          microchip.map((item, index) => (
            <Paper key={index} sx={{ p: 2, mb: 3 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mb: 2 }}
              >
                รายละเอียดไมโครชิพ
              </Typography>

              <Grid container spacing={2}>
                {/* วันที่ฉีดวัคซีน */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="วันที่ฝังไมโครชิพ"
                    fullWidth
                    type="date"
                    value={
                      item.implantDate
                        ? new Date(item.implantDate).toISOString().split("T")[0]
                        : ""
                    }
                    disabled
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                {/* Lot No */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="เลขไมโครชิพ."
                    placeholder="เลขไมโครชิพ"
                    fullWidth
                    value={item.microchipNumber}
                    disabled
                  />
                </Grid>
              </Grid>
            </Paper>
          ))}
        {/* ==============================
              ข้อมูลสัตวแพทย์
          =============================== */}
        <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
          สัตวแพทย์
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="สัตวแพทย์ผู้ให้บริการ"
              placeholder="กรุณาพิมพ์ชื่อสัตวแพทย์"
              fullWidth
              disabled
              value={vet.name}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="เลขที่ใบอนุญาต"
              placeholder="กรุณาพิมพ์เลขที่ใบอนุญาต (ถ้าระบุ)"
              fullWidth
              disabled
              value={vet.licenseNo}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="ชื่อสถานพยาบาล"
              placeholder="กรุณาพิมพ์ชื่อสถานพยาบาล"
              fullWidth
              disabled
              value={vet.hospital}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="ข้อมูลเพิ่มเติม"
              placeholder="กรุณาระบุรายละเอียด"
              multiline
              minRows={3}
              fullWidth
              disabled
              value={pet.note}
            />
          </Grid>
        </Grid>

        <Box sx={{ height: 50 }} />
      </Box>
    </>
  );
};

export default PetDetailPage;
